import React, { FC, HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import styles from './styles.module.scss';

interface ItemProps extends HTMLAttributes<HTMLDivElement> {
    active?: boolean,
    as?: string,
    badge?: number,
    content?: string | JSX.Element,
    href?: string,
    icon?: IconDefinition,
}

const Item: FC<ItemProps> = ({
    active,
    badge,
    children,
    className,
    content,
    href,
    icon,
    ...props
}): JSX.Element => {
    const elemProps: any = {
        className: [
            styles.item,
            active && styles.itemIsActive,
            className,
        ].join(' '),
        ...props
    }

    const innerContent = (<>
        {icon && (
            <div className={styles.itemIcon}>
                <FontAwesomeIcon icon={icon} />
            </div>
        )}
        <div className={styles.itemContent}>{children || content}</div>
        {badge !== undefined && <span className={styles.badge}>{badge}</span>}
    </>)

    if (href) {
        elemProps.to = href;
        return <Link {...elemProps}>{innerContent}</Link>;
    }

    const Elem = props.as || 'div';
    return <Elem {...elemProps}>{innerContent}</Elem>
}

export default Item;
